// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2lE6q","selected":"Chip_selected__3yClv"};